import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
import { Currency } from '~/Api/InfoCard';
var Headers;
(function (Headers) {
    Headers["date"] = "Datum objedn\u00E1vky";
    Headers["supplier"] = "N\u00E1zev protistrany";
    Headers["brand"] = "Brand";
    Headers["supplement"] = "Dopln\u011Bk n\u00E1zvu";
    Headers["suklCode"] = "S\u00DAKL k\u00F3d";
    Headers["unitPrice"] = "Jednotkov\u00E1 cena";
    Headers["contractUrl"] = "Detail smlouvy";
})(Headers || (Headers = {}));
export var UnitPrice = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group compact>
			<UITable celled collapsing striped unstackable size='small'>
				<UITable.Header>
					<UITable.Row>
						<UITable.HeaderCell data-testid='record-header'>{Headers.date}</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>{Headers.supplier}</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>{Headers.brand}</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>{Headers.supplement}</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>{Headers.suklCode}</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>{Headers.unitPrice}</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>{Headers.contractUrl}</UITable.HeaderCell>
					</UITable.Row>
				</UITable.Header>
				<UITable.Body>
					{detail.unitPriceRecords.map(function (record, i) {
            var date = new Date(record.date);
            return (<UITable.Row data-testid='record' key={i}>
								<UITable.Cell>{"".concat(date.getDate(), ".").concat(date.getMonth() + 1, ".").concat(date.getFullYear())}</UITable.Cell>
								<UITable.Cell>{record.supplier}</UITable.Cell>
								<UITable.Cell>{record.brand}</UITable.Cell>
								<UITable.Cell>{record.supplement}</UITable.Cell>
								<UITable.Cell>{record.suklCode}</UITable.Cell>
								<UITable.Cell textAlign='right'>{"".concat(record.unitPrice, " ").concat(Currency[detail.units.code])}</UITable.Cell>
								<UITable.Cell>
									<a href={record.contractUrl} target='_blank'>
										{record.contractUrl}
									</a>
								</UITable.Cell>
							</UITable.Row>);
        })}
				</UITable.Body>
			</UITable>
		</Segment.Group>
	</div>);
};
